import React, { useEffect, useState } from "react";
import { useAuth } from "@/auth/AuthProvider";
import AdminNav from "@/components/AdminNav";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

export default function Dashboard() {
  const { user, logout } = useAuth();

  const [stats, setStats] = useState<{
    total: number;
    queued: number;
    approved: number;
    declined: number;
    sessions?: number;
    serverTime?: number;
  } | null>(null);
  const [loading, setLoading] = useState(false);

  async function loadStats() {
    setLoading(true);
    try {
      const res = await fetch("/api/admin/stats");
      if (!res.ok) return;
      const data = await res.json();
      if (data?.ok) {
        setStats({
          total: data.total ?? 0,
          queued: data.queued ?? 0,
          approved: data.approved ?? 0,
          declined: data.declined ?? 0,
          sessions: data.sessions,
          serverTime: data.serverTime,
        });
      }
    } catch (err) {
      // ignore
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    loadStats();
    const id = setInterval(loadStats, 5000);
    return () => clearInterval(id);
  }, []);

  return (
    <>
      <AdminNav />
      <div className="min-h-screen p-8 bg-background">
        <div className="max-w-6xl mx-auto mt-6">
          <div className="flex items-center justify-between mb-6">
            <div>
              <h1 className="text-3xl font-bold">Welcome, {user?.name ?? user?.username}</h1>
              <p className="text-sm text-muted-foreground">This page is only meant for administrators.</p>
            </div>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mt-6">
            <div className="rounded-lg border bg-card p-4">
              <div className="text-sm text-muted-foreground">Total</div>
              <div className="text-2xl font-bold">{stats?.total ?? "—"}</div>
            </div>
            <div className="rounded-lg border bg-card p-4">
              <div className="text-sm text-muted-foreground">Queued</div>
              <div className={"text-2xl font-bold" + (stats?.queued !== 0 ? " animate-pulse text-destructive" : "")}>{stats?.queued ?? "—"}</div>
            </div>
            <div className="rounded-lg border bg-card p-4">
              <div className="text-sm text-muted-foreground">Approved</div>
              <div className="text-2xl font-bold">{stats?.approved ?? "—"}</div>
            </div>
            <div className="rounded-lg border bg-card p-4">
              <div className="text-sm text-muted-foreground">Declined</div>
              <div className="text-2xl font-bold">{stats?.declined ?? "—"}</div>
            </div>
          </div>
          <div className="flex items-center gap-3 mt-4">
            <Button onClick={() => loadStats()} size="sm">Refresh</Button>
            <div className="text-sm text-muted-foreground">{loading ? "Loading…" : stats ? `Last sync: ${new Date(stats.serverTime || Date.now()).toLocaleTimeString()}` : "Not loaded"}</div>
          </div>
        </div>
      </div>
    </>
  );
}
